import './App.css';
import './HomeLoggedOut.js';

import Home from './Home';

import React, { createContext } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import HomeLoggedOut from './HomeLoggedOut.js';

export const AppUserContext = createContext({});

function App() {

  // const [appUser, setAppUser] = useState({});
  const { isLoading, isAuthenticated, error } = useAuth0();

  if (isLoading) {
    return <div>Loading...</div>;
  }
  if (error) {
    return <div>Oops... {error.message}</div>;
  }

  if (isAuthenticated) {
    // setAppUser({})
    return (
        // <AppUserContext.Provider value={{ appUser, setAppUser }}>
            <Home />
        // </AppUserContext.Provider>
    );
  } else {
    return <HomeLoggedOut />;
  }
}

export default App;
